import { TableColumnMeta } from "ds/components/Table/types";
import { StarFilled } from "components/icons/generated";

export enum MODULES_COLUMN_ID {
  VERSION = "VERSION",
  NAME = "NAME",
  LABELS = "LABELS",
  SPACE = "SPACE",
  CREATED_AT = "CREATED_AT",
  LAST_PULLED_AT = "LAST_PULLED_AT",
  DESCRIPTION = "DESCRIPTION",
  PROVIDER = "PROVIDER",
  PROJECT_ROOT = "PROJECT_ROOT",
  REPOSITORY = "REPOSITORY",
  DROPDOWN = "DROPDOWN",
  AVAILABILITY = "AVAILABILITY",
  FAVORITE = "FAVORITE",
  BRANCH = "BRANCH",
  ID = "ID",
  SETTINGS = "SETTINGS",
}

const MAX_CELL_WIDTH = 2500;

export const MODULES_COLUMNS_STORAGE_KEY = "modulesColumnsConfig";

export const MODULES_COLUMN_CONFIG: Record<MODULES_COLUMN_ID, TableColumnMeta> = {
  [MODULES_COLUMN_ID.VERSION]: {
    id: MODULES_COLUMN_ID.VERSION,
    title: "Version",
    minWidth: 105,
    defaultWidth: 105,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [MODULES_COLUMN_ID.ID]: {
    id: MODULES_COLUMN_ID.ID,
    title: "ID",
    minWidth: 100,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    allowsSorting: true,
  },
  [MODULES_COLUMN_ID.NAME]: {
    id: MODULES_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 300,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [MODULES_COLUMN_ID.FAVORITE]: {
    id: MODULES_COLUMN_ID.FAVORITE,
    title: "Favorite",
    iconOnly: true,
    icon: StarFilled,
    minWidth: 100,
    defaultWidth: 100,
    maxWidth: 100,
    resizable: false,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [MODULES_COLUMN_ID.DESCRIPTION]: {
    id: MODULES_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 130,
    defaultWidth: 240,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [MODULES_COLUMN_ID.AVAILABILITY]: {
    id: MODULES_COLUMN_ID.AVAILABILITY,
    title: "Availability",
    minWidth: 130,
    defaultWidth: 160,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [MODULES_COLUMN_ID.PROVIDER]: {
    id: MODULES_COLUMN_ID.PROVIDER,
    title: "Provider",
    minWidth: 110,
    defaultWidth: 110,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [MODULES_COLUMN_ID.SPACE]: {
    id: MODULES_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 112,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [MODULES_COLUMN_ID.SETTINGS]: {
    id: MODULES_COLUMN_ID.SETTINGS,
    title: "Settings",
    minWidth: 110,
    defaultWidth: 110,
    maxWidth: MAX_CELL_WIDTH,
    canHide: true,
    resizable: true,
    canPin: true,
    canMove: true,
  },
  [MODULES_COLUMN_ID.LABELS]: {
    id: MODULES_COLUMN_ID.LABELS,
    title: "Labels",
    minWidth: 100,
    defaultWidth: 140,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [MODULES_COLUMN_ID.PROJECT_ROOT]: {
    id: MODULES_COLUMN_ID.PROJECT_ROOT,
    title: "Project root",
    minWidth: 100,
    defaultWidth: 140,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [MODULES_COLUMN_ID.REPOSITORY]: {
    id: MODULES_COLUMN_ID.REPOSITORY,
    title: "Repository",
    minWidth: 130,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [MODULES_COLUMN_ID.BRANCH]: {
    id: MODULES_COLUMN_ID.BRANCH,
    title: "Branch",
    minWidth: 130,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [MODULES_COLUMN_ID.CREATED_AT]: {
    id: MODULES_COLUMN_ID.CREATED_AT,
    title: "Created at",
    minWidth: 145,
    defaultWidth: 160,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [MODULES_COLUMN_ID.LAST_PULLED_AT]: {
    id: MODULES_COLUMN_ID.LAST_PULLED_AT,
    title: "Last pulled at",
    minWidth: 145,
    defaultWidth: 160,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [MODULES_COLUMN_ID.DROPDOWN]: {
    id: MODULES_COLUMN_ID.DROPDOWN,
    title: "Modules actions",
    noHeader: true,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
    canPin: false,
    canMove: false,
  },
};

export const MODULES_SORT_CONFIG: Record<string, string> = {
  [MODULES_COLUMN_ID.NAME]: "name",
  [MODULES_COLUMN_ID.CREATED_AT]: "createdAt",
  [MODULES_COLUMN_ID.SPACE]: "space",
  [MODULES_COLUMN_ID.FAVORITE]: "starred",
  [MODULES_COLUMN_ID.ID]: "slug",
};
